const getPriceSource = (propertyOrPrice) =>
  propertyOrPrice && typeof propertyOrPrice === "object" && "price" in propertyOrPrice
    ? propertyOrPrice.price
    : propertyOrPrice;

export const getPriceAmount = (propertyOrPrice) => {
  const price = getPriceSource(propertyOrPrice);

  if (typeof price === "number") return price;

  if (price && typeof price === "object") {
    return getPriceAmount(price.amount ?? price.value ?? price.precio);
  }

  if (typeof price === "string") {
    const match = price.replace(/,/g, "").match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  }

  return 0;
};

export const getRentTaxLabel = (propertyOrPrice) => {
  const price = getPriceSource(propertyOrPrice);
  const fallbackIva =
    propertyOrPrice && typeof propertyOrPrice === "object" && "iva" in propertyOrPrice
      ? propertyOrPrice.iva
      : undefined;

  if (price && typeof price === "object") {
    const objectIva = price.iva ?? price.tax ?? price.impuesto;
    return getRentTaxLabel({
      price: price.label ?? "",
      iva: objectIva ?? fallbackIva,
    });
  }

  if (typeof price === "string") {
    const normalized = price
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (
      normalized.includes("sin iva") ||
      normalized.includes("no iva") ||
      normalized.includes("no lleva iva")
    ) {
      return "sin IVA";
    }

    if (
      normalized.includes("iva incluido") ||
      normalized.includes("iva incluida") ||
      normalized.includes("incluye iva")
    ) {
      return "IVA incluido";
    }

    if (normalized.includes("iva")) return "+ IVA";
  }

  if (typeof fallbackIva === "string") return fallbackIva;
  if (fallbackIva === true) return "+ IVA";
  if (fallbackIva === false) return "sin IVA";

  return "";
};

export const formatPrice = (propertyOrPrice) => {
  const amount = getPriceAmount(propertyOrPrice);

  if (!amount) {
    const price = getPriceSource(propertyOrPrice);
    return typeof price === "string" ? price : "";
  }

  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
